import { ElementRef, OnChanges } from '@angular/core';
/**
 * The iframe itself: sizing, loading state and the transport to the hosted app.
 * All routing and protocol decisions live in ReactAppComponent.
 */
var ReactFrameComponent = /** @class */ (function () {
    function ReactFrameComponent() {
        this.title = 'Aplicación';
        this.isLoading = true;
    }
    ReactFrameComponent.prototype.ngOnChanges = function () {
        // A new src means a brand new document load: show the loading state again.
        this.isLoading = true;
    };
    ReactFrameComponent.prototype.onLoad = function () {
        this.isLoading = false;
    };
    Object.defineProperty(ReactFrameComponent.prototype, "contentWindow", {
        /** Window of the hosted app, used by the shell to validate message senders. */
        get: function () {
            var frame = this.frameElement();
            return frame ? frame.contentWindow : null;
        },
        enumerable: false,
        configurable: true
    });
    ReactFrameComponent.prototype.postMessage = function (message) {
        var childWindow = this.contentWindow;
        if (!childWindow) {
            return;
        }
        childWindow.postMessage(message, window.location.origin);
    };
    ReactFrameComponent.prototype.frameElement = function () {
        return this.frame ? this.frame.nativeElement : null;
    };
    return ReactFrameComponent;
}());
export { ReactFrameComponent };
